var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCohort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 62,
    viewBox: "0 0 365 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 365,
    height: 62,
    rx: 15,
    fill: "#F9F9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 12,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#DCE0E6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 15.5,
    width: 269,
    height: 14,
    rx: 6,
    fill: "#DCE0E6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 37.5,
    width: 197,
    height: 10,
    rx: 4,
    fill: "#EFEFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCohort);
export default __webpack_public_path__ + "static/media/empty-cohort.ba11a5874476ac9661b53c1dd6f548b2.svg";
export { ForwardRef as ReactComponent };